import {
  SET_SELECTED_CALENDAR,
  SET_PLANNER_MODE,
  SET_LOADED_WEEK_RANGE,
  LOAD_MORE_WEEKS_START,
  LOAD_MORE_WEEKS_FULFILLED,
  LOAD_MORE_WEEKS_REJECTED,
  LOAD_MORE_WEEKS_AND_BLOCKS_FULFILLED,
  FETCH_PLANNER_START,
  FETCH_PLANNER_FULFILLED,
  FETCH_PLANNER_REJECTED,
  SET_PLANNER_EXAMPLES_MODAL_OPEN,
  SET_SELECTED_CALENDAR_NAME,
} from './actionTypes';

// localStorage key for persisting planner mode
const PLANNER_MODE_STORAGE_KEY = 'teambuildr_planner_mode';

// Get initial mode from localStorage, default to 'plan'
const getInitialMode = () => {
  try {
    const savedMode = localStorage.getItem(PLANNER_MODE_STORAGE_KEY);
    return savedMode === 'review' ? 'review' : 'plan';
  } catch (error) {
    return 'plan';
  }
};

const initialState = {
  // Calendar selection
  selectedCalendarId: null,
  selectedCalendarName: null,

  // Mode: 'plan' or 'review' (persisted in localStorage)
  mode: getInitialMode(),

  // Loaded week range for infinite scrolling
  loadedWeekRange: {
    fromWeek: null,
    toWeek: null,
  },

  // Loading states
  isPlannerLoading: false,
  isLoadingMoreWeeks: false,

  // Error states
  plannerError: null,

  // Examples modal
  isPlannerExamplesModalOpen: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_SELECTED_CALENDAR: {
      return {
        ...state,
        selectedCalendarId: action.payload,
      };
    }

    case SET_PLANNER_MODE: {
      const validModes = ['plan', 'review'];
      if (!validModes.includes(action.payload)) {
        return state;
      }

      try {
        localStorage.setItem(PLANNER_MODE_STORAGE_KEY, action.payload);
      } catch (error) {
        // Fail silently if localStorage is not available
      }

      return {
        ...state,
        mode: action.payload,
      };
    }

    case SET_LOADED_WEEK_RANGE: {
      return {
        ...state,
        loadedWeekRange: action.payload,
      };
    }

    case LOAD_MORE_WEEKS_START: {
      return {
        ...state,
        isLoadingMoreWeeks: true,
      };
    }

    case LOAD_MORE_WEEKS_FULFILLED: {
      return {
        ...state,
        isLoadingMoreWeeks: false,
        loadedWeekRange: action.payload,
      };
    }

    case LOAD_MORE_WEEKS_AND_BLOCKS_FULFILLED: {
      const { fromWeek, toWeek } = action.payload;
      return {
        ...state,
        isLoadingMoreWeeks: false,
        loadedWeekRange: { fromWeek, toWeek },
      };
    }

    case LOAD_MORE_WEEKS_REJECTED: {
      return {
        ...state,
        isLoadingMoreWeeks: false,
      };
    }

    case FETCH_PLANNER_START: {
      return {
        ...state,
        isPlannerLoading: true,
        plannerError: null,
      };
    }

    case FETCH_PLANNER_FULFILLED: {
      return {
        ...state,
        isPlannerLoading: false,
      };
    }

    case FETCH_PLANNER_REJECTED: {
      return {
        ...state,
        isPlannerLoading: false,
        plannerError: action.payload,
      };
    }

    case SET_PLANNER_EXAMPLES_MODAL_OPEN: {
      return {
        ...state,
        isPlannerExamplesModalOpen: action.payload,
      };
    }

    case SET_SELECTED_CALENDAR_NAME: {
      return {
        ...state,
        selectedCalendarName: action.payload,
      };
    }

    default:
      return state;
  }
}
